module.exports = "/img/table-empty.93ea99c7.png";